<template>
  <div class="organization-editor responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="pageHeader"
        :hideAddButton="true"
        :selectedEntity="selectedOrganization"
        :links="[
          { name: 'home', label: 'Home' },
          {
            name: 'organizationEditor',
            label: selectedOrganization.name,
            query: $route.query,
          },
        ]"
        @toggle-edit="toggleEdit"
        @toggle-sections="forceToggle"
        @updateIsEdit="isEdit = $event"
        :isEdit="isEdit"
        :entity="entity"
        :isCollapsed="isCollapsed"
      >
        <!-- <Button label="Sync Stores" iconGroup="fas" iconName="file-export" :colorType="2"
          @click="syncStores()" :isLoading="stateLoadingStatus.pullStores" /> -->

        <!-- <Button label="Sync Category Types" iconGroup="fas" iconName="file-export" :colorType="2"
        @click="syncCategoryTypes()" :isLoading="stateLoadingStatus.pullCategoryTypes" /> -->

        <!-- <Button label="Sync Unit of Measure" iconGroup="fas" iconName="file-export" :colorType="2"
        @click="syncUnitOfMeasures()" :isLoading="stateLoadingStatus.pullUnitOfMeasures" /> -->
      </PageHeader>

      <div class="section-base">
        <div class="padded elevated-0 bordered">
          <div class="two-columns-layout two-columns-layout--responsive">
            <div
              class="
                grid-two-column
                two-columns-layout--responsive-horizontal-space-10
              "
            >
              <div
                v-for="input in mainInputs"
                :key="input.id"
                :class="'input-text' + ' ' + input.class"
              >
                <Input
                  :model="selectedOrganization[input.id]"
                  @updateModel="selectedOrganization[input.id] = $event"
                  :inputData="input"
                  :isEdit="isEdit"
                />
              </div>
            </div>
            <div>
              <div
                class="
                  two-columns-layout
                  two-columns-layout--responsive-horizontal-space-10
                "
              >
                <div>
                  <div class="input-text">
                    <div class="reversed-flex-column">
                      <FileUploader
                        label="Upload Logo"
                        allowedTypes="image/png, image/jpeg"
                        @change="updateImage"
                        :disabled="!isEdit"
                      />
                      <div class="input-text__label">Organization Logo</div>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    v-if="
                      this.selectedOrganization.imageNormal &&
                      (this.selectedOrganization.imageNormal.data ||
                        this.selectedOrganization.imageNormal.secure_url)
                    "
                    class="input-text"
                  >
                    <div class="reversed-flex-column">
                      <div>
                        <inline-button
                          label="Remove Logo"
                          type="plain-danger responsive-column form-height wide"
                          @click="() => removeImage()"
                          :disabled="!isEdit"
                        />
                      </div>

                      <div class="input-text__label">Organization Logo</div>
                    </div>
                  </div>
                </div>
              </div>
              <img
                :src="
                  this.selectedOrganization.imageNormal &&
                  (this.selectedOrganization.imageNormal.data
                    ? this.selectedOrganization.imageNormal.data
                    : this.selectedOrganization.imageNormal.secure_url)
                "
                class="image-preview"
                alt
              />
            </div>
          </div>
        </div>
      </div>

      <EditorSection
        :title="`About ${selectedOrganization.name || ''}`"
        sectionType="about"
        v-if="selectedOrganization._id !== 'NEW'"
        :bus="bus"
      >
        <About
          v-if="selectedOrganization._id !== undefined"
          :entity="selectedOrganization"
        />
      </EditorSection>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import PageHeader from "@/components/PageHeader.vue";
import About from "@/components/About/About.vue";
import EditorSection from "@/components/EditorSection.vue";
import { mapActions, mapGetters } from "vuex";
import Constants from "@/resources/Constants";
import FileUploader from "@/components/FileUploader/FileUploader.vue";
import Input from "@/components/Input/Input.vue";
import { mainInputs, pageHeader } from "./inputs";
import Entities from "@/resources/Entities";
import Button from "@/components/Base/Button/Button.vue";

export default {
  name: "organizationEditor",
  data() {
    return {
      Constants: Constants,
      mainInputs,
      isEdit: false,
      isCollapsed: true,
      bus: new Vue(),
      entity: Entities.ORGANIZATION,
      pageHeader,
    };
  },
  components: {
    PageHeader,
    About,
    FileUploader,
    EditorSection,
    Input,
    // Button,
  },
  mounted: function () {
    this.setPageTitle("Organization");
    if (this.$route.query.id) {
      this.getOrganizationById({
        _id: this.$route.query.id,
      });
    } else {
      this.setMessage({
        text: "Cannot create more than one organization",
        type: "error",
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      this.setMessagePopUp({
        isOpen: true,
        title: Constants.strings.unsavedChangesTitle,
        message: Constants.strings.unsavedChangesConfirmation,
        positiveCallback: (data) => {
          next(true);
        },
      });
    } else {
      next(true);
    }
  },
  watch: {
    id: function () {
      if (this.id && this.id !== "NEW") {
        this.getOrganizationById({
          _id: this.id,
        });
        document.getElementById("app-body").scrollTo(0, 0);
      }
    },
  },
  computed: {
    id: {
      get() {
        return this.$route.query.id;
      },
      set(id) {
        return id;
      },
    },
    ...mapGetters({
      loadingStatus: "organizationModule/loadingStatus",
      organization: "organizationModule/organization",
      stateLoadingStatus: "stateModule/loadingStatus",
    }),
    selectedOrganization: {
      get() {
        if (this.$route.query.id && this.organization) {
          this.setPageTitle(`Organization ${this.organization.name}`);
          return this.organization;
        } else {
          const result = {};
          return result;
        }
      },
      set(entity) {
        return entity;
      },
    },
  },
  methods: {
    ...mapActions({
      getOrganizationById: "organizationModule/getOrganizationById",
      saveOrganization: "organizationModule/saveOrganization",
      setMessage: "setMessage",
      setMessagePopUp: "setMessagePopUp",
      pullStores: "stateModule/pullStores",
      pullCategoryTypes: "stateModule/pullCategoryTypes",
      pullUnitOfMeasures: "stateModule/pullUnitOfMeasures",
    }),
    getInput(field) {
      return this.mainInputs.find((i) => i.id == field);
    },
    performSave() {
      if (
        this.loadingStatus.saveOrganization ||
        this.selectedOrganization._id === undefined ||
        this.selectedOrganization._id === "NEW"
      ) {
        return;
      }

      const organizationToSave = this.normalizeEntityBeforeSaving(
        this.selectedOrganization
      );

      this.saveOrganization({
        organization: organizationToSave,
        positiveCallback: (organization) => {
          this.setPageTitle(`Organization ${organization.name}`);
          this.selectedOrganization = organization;
          this.isEdit = false;
        },
      });
    },
    normalizeEntityBeforeSaving(organization) {
      const entity = JSON.parse(JSON.stringify(organization));
      if (entity.state && entity.state.abbreviation) {
        entity.state = entity.state.abbreviation;
      }
      return entity;
    },
    updateImage(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0]);
    },
    createImage(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        if (!this.selectedOrganization.imageNormal) {
          this.selectedOrganization.imageNormal = {};
        }
        this.selectedOrganization.imageNormal.data = e.target.result;
        this.$forceUpdate();
      };
      reader.readAsDataURL(file);
    },
    removeImage: function () {
      this.selectedOrganization.imageNormal = undefined;
      this.selectedOrganization.imageThumbnail = undefined;
    },
    forceToggle() {
      this.isCollapsed = !this.isCollapsed;
      this.bus.$emit("forceToggle", this.isCollapsed);
    },
    toggleEdit() {
      if (!(this.selectedOrganization._id === "NEW"))
        this.isEdit = !this.isEdit;
      if (this.selectedOrganization._id === "NEW") {
        this.isEdit = true;
      }
    },
    syncStores() {
      const positiveCallback = (response) => {
          const {successCount, failedStrains} = response

          if(failedStrains?.length > 0) {
            const failedStrainsNames = failedStrains?.map(m => m.message).join("\n");
            this.setMessage({
              title: "Partial State Sync",
              text: "Synced " + successCount + " stores.\n\nFailed to sync " + failedStrains.length + " stores:\n" + failedStrainsNames,
              type: "state-error"
            });
            return;
          }

          const text = successCount > 0 ? "Synced " + successCount + " store(s)!" : "Up to date!";
          this.setMessage({
            isOpen: true,
            text: text,
            type: "success"
          });
      };

      this.pullStores({positiveCallback});
    },
    syncCategoryTypes() {
      const positiveCallback = (response) => {
          const {successCount, failedCategoryTypes} = response

          if(failedCategoryTypes?.length > 0) {
            const failedCategoryTypesNames = failedCategoryTypes?.map(m => m.message).join("\n");
            this.setMessage({
              title: "Partial State Sync",
              text: "Synced " + successCount + " category types.\n\nFailed to sync " + failedCategoryTypes.length + " category types:\n" + failedCategoryTypesNames,
              type: "state-error"
            });
            return;
          }

          const text = successCount > 0 ? "Synced " + successCount + " category type(s)!" : "Up to date!";
          this.setMessage({
            isOpen: true,
            text: text,
            type: "success"
          });
      };

      this.pullCategoryTypes({positiveCallback});
    },
    syncUnitOfMeasures() {
      const positiveCallback = (response) => {
        const {successCount, failedUnitOfMeasures} = response

        if(failedUnitOfMeasures?.length > 0) {
          const failedUnitOfMeasuresNames = failedUnitOfMeasures?.map(m => m.message).join("\n");
        }

        const text = successCount > 0 ? "Synced " + successCount + " unit of measure(s)!" : "Up to date!";
        this.setMessage({
          isOpen: true,
          text: text,
          type: "success"
        });
      };

      this.pullUnitOfMeasures({positiveCallback});
    }
  },
};
</script>

<style scoped lang="scss">
.image-preview {
  width: 300px;
}
</style>
